import VueSimpleSuggest from './vue-simple-suggest.vue'
export default VueSimpleSuggest
